module.exports = __webpack_public_path__ + "img/money.77e5c614.png";